const translations = {
  en: {
    // Search
    search: "Search...",
    searchSchedules: "Search schedules...",
    searchArtists: "Search artists...",
    searchEvents: "Search events...",
    searchPlaces: "Search places...",
    clearSearch: "Clear search",

    // Navigation
    back: "Back",

    // Tabs & Views
    byStage: "By Stage",
    byTime: "By Time",

    // Day selector
    allDays: "All days",
    all: "All",
    date: "Date",

    // Filters
    categories: "Categories",
    placeTypes: "Place types",
    stages: "Stages",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    clear: "Clear",
    clearFilters: "Clear filters",
    noResults: "No results",

    // Empty states
    noArtistsFound: "No artists found",
    noEventsFound: "No events found",
    noSchedulesForDay: "No schedules for this day",
    noPlacesFound: "No places found",
    emptyStateHint: "Try adjusting your search or filters",

    // Errors
    failedToLoadEdition: "Failed to load edition data",
    artistNotFound: "Artist not found",
    eventNotFound: "Event not found",
    placeNotFound: "Place not found",

    // Section titles
    schedule: "Schedule",
    performers: "Performers",
    media: "Media",
    info: "Info",

    // Social platforms
    instagram: "Instagram",
    facebook: "Facebook",
    x: "X",
    tiktok: "TikTok",
    soundcloud: "SoundCloud",
    spotify: "Spotify",
    appleMusic: "Apple Music",
    deezer: "Deezer",
    tidal: "Tidal",
    lastfm: "Last.fm",
    musicbrainz: "MusicBrainz",
    wikipedia: "Wikipedia",
    youtube: "YouTube",
    website: "Website",

    // App prompt modal
    appPromptMessage: "There's an app for this festival!",
    openApp: "Open App",
    cancel: "Cancel",

    // Powered by badge
    poweredBy: "Powered by",

    // Tickets
    getTickets: "Tickets",
  },
  fr: {
    // Search
    search: "Rechercher...",
    searchSchedules: "Rechercher des horaires...",
    searchArtists: "Rechercher des artistes...",
    searchEvents: "Rechercher des événements...",
    searchPlaces: "Rechercher des lieux...",
    clearSearch: "Effacer la recherche",

    // Navigation
    back: "Retour",

    // Tabs & Views
    byStage: "Par scène",
    byTime: "Par horaire",

    // Day selector
    allDays: "Tous les jours",
    all: "Tout",
    date: "Date",

    // Filters
    categories: "Catégories",
    placeTypes: "Types de lieu",
    stages: "Scènes",
    selectAll: "Tout sélectionner",
    deselectAll: "Tout désélectionner",
    clear: "Effacer",
    clearFilters: "Effacer les filtres",
    noResults: "Aucun résultat",

    // Empty states
    noArtistsFound: "Aucun artiste trouvé",
    noEventsFound: "Aucun événement trouvé",
    noSchedulesForDay: "Aucun horaire pour ce jour",
    noPlacesFound: "Aucun lieu trouvé",
    emptyStateHint: "Essayez d'ajuster votre recherche ou vos filtres",

    // Errors
    failedToLoadEdition: "Échec du chargement des données",
    artistNotFound: "Artiste non trouvé",
    eventNotFound: "Événement non trouvé",
    placeNotFound: "Lieu non trouvé",

    // Section titles
    schedule: "Horaires",
    performers: "Artistes",
    media: "Médias",
    info: "Infos",

    // Social platforms
    instagram: "Instagram",
    facebook: "Facebook",
    x: "X",
    tiktok: "TikTok",
    soundcloud: "SoundCloud",
    spotify: "Spotify",
    appleMusic: "Apple Music",
    deezer: "Deezer",
    tidal: "Tidal",
    lastfm: "Last.fm",
    musicbrainz: "MusicBrainz",
    wikipedia: "Wikipédia",
    youtube: "YouTube",
    website: "Site web",

    // App prompt modal
    appPromptMessage: "Il y a une appli pour ce festival !",
    openApp: "Ouvrir l'appli",
    cancel: "Annuler",

    // Powered by badge
    poweredBy: "Propulsé par",

    // Tickets
    getTickets: "Billets",
  },
  es: {
    // Search
    search: "Buscar...",
    searchSchedules: "Buscar horarios...",
    searchArtists: "Buscar artistas...",
    searchEvents: "Buscar eventos...",
    searchPlaces: "Buscar lugares...",
    clearSearch: "Borrar búsqueda",

    // Navigation
    back: "Volver",

    // Tabs & Views
    byStage: "Por escenario",
    byTime: "Por horario",

    // Day selector
    allDays: "Todos los días",
    all: "Todo",
    date: "Fecha",

    // Filters
    categories: "Categorías",
    placeTypes: "Tipos de lugar",
    stages: "Escenarios",
    selectAll: "Seleccionar todo",
    deselectAll: "Deseleccionar todo",
    clear: "Borrar",
    clearFilters: "Borrar filtros",
    noResults: "Sin resultados",

    // Empty states
    noArtistsFound: "No se encontraron artistas",
    noEventsFound: "No se encontraron eventos",
    noSchedulesForDay: "No hay horarios para este día",
    noPlacesFound: "No se encontraron lugares",
    emptyStateHint: "Intenta ajustar tu búsqueda o filtros",

    // Errors
    failedToLoadEdition: "Error al cargar los datos",
    artistNotFound: "Artista no encontrado",
    eventNotFound: "Evento no encontrado",
    placeNotFound: "Lugar no encontrado",

    // Section titles
    schedule: "Horarios",
    performers: "Artistas",
    media: "Medios",
    info: "Info",

    // Social platforms
    instagram: "Instagram",
    facebook: "Facebook",
    x: "X",
    tiktok: "TikTok",
    soundcloud: "SoundCloud",
    spotify: "Spotify",
    appleMusic: "Apple Music",
    deezer: "Deezer",
    tidal: "Tidal",
    lastfm: "Last.fm",
    musicbrainz: "MusicBrainz",
    wikipedia: "Wikipedia",
    youtube: "YouTube",
    website: "Sitio web",

    // App prompt modal
    appPromptMessage: "¡Hay una app para este festival!",
    openApp: "Abrir App",
    cancel: "Cancelar",

    // Powered by badge
    poweredBy: "Desarrollado por",

    // Tickets
    getTickets: "Entradas",
  },
} as const;

export type Locale = keyof typeof translations;
export type TranslationKey = keyof (typeof translations)["en"];

export function getTranslations(locale: Locale) {
  return translations[locale] ?? translations.en;
}

export function t(locale: Locale, key: TranslationKey): string {
  return translations[locale]?.[key] ?? translations.en[key];
}
